import React from 'react';
import MenuCategory from './MenuCategory';
import useSEO from '../hooks/useSEO';

const Menu = () => {
  useSEO({
    title: "Menü | Etçi Kısmet",
    description: "Etçi Kısmet menüsü: etler, salatalar, tatlılar ve içecekler. Taze et çeşitleri ve lezzetli yemeklerimizi keşfedin.",
    path: '/menu'
  });

  // Menu data organized by categories
  const menuData = {
    etler: {
      title: "ETLER",
      items: [
        {
          id: 1,
          name: "ET",
          nameEn: "MEAT, МЯСО",
          price: "3000 TL / KG",
          image: "/images/et.jpeg"
        },
        {
          id: 2,
          name: "LOKUM",
          nameEn: "TURKISH BONELESS, РАХАТ ЛУКУМ",
          price: "3700 TL / KG",
          image: "/images/lokum.jpeg"
        },
        {
          id: 3,
          name: "KÜŞLEME",
          nameEn: "TENDERLOIN, ВЫРЕЗКА",
          price: "3700 TL / KG",
          image: "/images/kusleme.jpeg"
        },
        {
          id: 4,
          name: "T-BONE STEAK",
          nameEn: "T-BONE STEAK, Т-БОН СТЕЙК",
          price: "3000 TL / KG",
          image: "/images/tbone.jpeg"
        },
        {
          id: 5,
          name: "DALLAS STEAKS",
          nameEn: "DALLAS STEAKS, ДАЛЛАС СТЕЙКИ",
          price: "3000 TL / KG",
          image: "/images/dallas.png"
        },
        {
          id: 6,
          name: "KÖFTE",
          nameEn: "MEATBALLS, ФРИКАДЕЛЬКИ",
          price: "2000 TL / KG",
          image: "/images/kofte.jpg"
        },
        {
          id: 7,
          name: "SUCUK",
          nameEn: "TURKISH SAUSAGE, ТУРЕЦКАЯ КОЛБАСА",
          price: "2000 TL / KG",
          image: "/images/sucuk.jpg"
        },
        {
          id: 8,
          name: "ÇOCUK HAMBURGER",
          nameEn: "KIDS BURGER, ДЕТСКИЙ БУРГЕР",
          price: "500 TL",
          image: "/images/cocuk-hamburger.jpg"
        },
        {
          id: 9,
          name: "CİĞER / BÖBREK",
          nameEn: "LIVER / KIDNEY, ПЕЧЕНЬ / ПОЧКИ",
          price: "3000 TL / KG",
          image: "/images/ciger.jpeg"
        }
      ]
    },
    salatalar: {
      title: "SALATALAR",
      items: [
        {
          id: 10,
          name: "MEVSİM SALATA",
          nameEn: "SEASONAL SALAD, СЕЗОННЫЙ САЛАТ",
          price: "TEK 220 TL / DOUBLE 350 TL",
          image: "/images/mevsimsalata.png"
        },
        {
          id: 11,
          name: "KAŞIK SALATA",
          nameEn: "SPOON SALAD, ЛОЖЕЧНЫЙ САЛАТ",
          price: "TEK 220 TL / DOUBLE 350 TL",
          image: "/images/kasiksalata_1.jpg"
        },
        {
          id: 12,
          name: "ÇOBAN SALATA",
          nameEn: "SHEPHERD SALAD, ПАСТУШИЙ САЛАТ",
          price: "TEK 220 TL / DOUBLE 350 TL",
          image: "/images/cobansalata.jpg"
        },
        {
          id: 13,
          name: "GAVURDAĞ SALATA",
          nameEn: "GAVURDAĞ SALAD, ГАВУРДАГ САЛАТ",
          price: "TEK 250 TL / DOUBLE 400 TL",
          image: "/images/gavurdag.jpg"
        }
      ]
    },
    tatlilar: {
      title: "TATLILAR",
      items: [
        {
          id: 14,
          name: "SÜTLAÇ",
          nameEn: "RICE PUDDING, РИСОВЫЙ ПУДИНГ",
          price: "225 TL",
          image: "/images/sutlac.jpg"
        },
        {
          id: 15,
          name: "HAVUÇ DİLİM BAKLAVA",
          nameEn: "CARROT SLICE BAKLAVA, МОРКОВНЫЙ ЛОМТИК БАКЛАВА",
          price: "250 TL",
          image: "/images/hbaklava.webp"
        },
        {
          id: 16,
          name: "KABAK",
          nameEn: "PUMPKIN DESSERT, ТЫКВЕННЫЙ ДЕСЕРТ",
          price: "250 TL",
          image: "/images/kabak-tatlisi.webp"
        }
      ]
    },
    icecekler: {
      title: "İÇECEKLER",
      items: [
        {
          id: 17,
          name: "KÜÇÜK SU",
          nameEn: "SMALL WATER, МАЛЕНЬКАЯ ВОДА",
          price: "45 TL",
          image: "/images/kerikli.webp"
        },
        {
          id: 18,
          name: "BÜYÜK SU",
          nameEn: "LARGE WATER, БОЛЬШАЯ ВОДА",
          price: "70 TL",
          image: "/images/kerikli.webp"
        },
        {
          id: 19,
          name: "KOLA",
          nameEn: "COLA, КОЛА",
          price: "90 TL",
          image: "/images/kkola.jpeg"
        },
        {
          id: 20,
          name: "ICE TEA",
          nameEn: "ICE TEA, ХОЛОДНЫЙ ЧАЙ",
          price: "90 TL",
          image: "/images/fusetea.webp"
        },
        {
          id: 21,
          name: "SPRİTE",
          nameEn: "SPRITE, СПРАЙТ",
          price: "90 TL",
          image: "/images/sprite.jpeg"
        },
        {
          id: 22,
          name: "FANTA",
          nameEn: "FANTA, ФАНТА",
          price: "90 TL",
          image: "/images/fanta.jpeg"
        },
        {
          id: 23,
          name: "AYRAN",
          nameEn: "AYRAN, АЙРАН",
          price: "80 TL",
          image: "/images/ayran.jpg"
        },
        {
          id: 24,
          name: "AÇIK AYRAN",
          nameEn: "OPEN AYRAN, ОТКРЫТЫЙ АЙРАН",
          price: "80 TL",
          image: "/images/acikayran.jpg"
        },
        {
          id: 25,
          name: "ZAFER",
          nameEn: "ZAFER, ЗАФЕР",
          price: "80 TL",
          image: "/images/zafer2-removebg-preview.png"
        },
        {
          id: 26,
          name: "ŞALGAM",
          nameEn: "TURNIP JUICE, СОК РЕПЫ",
          price: "80 TL",
          image: "/images/salgam.jpg"
        },
        {
          id: 27,
          name: "SODA",
          nameEn: "SODA, СОДА",
          price: "70 TL",
          image: "/images/soda.jpg"
        }
      ]
    },
    mezeler: {
      title: "MEZELER",
      items: [
        {
          id: 28,
          name: "MEZELER",
          nameEn: "APPETIZERS, ЗАКУСКИ",
          price: "220 TL",
          image: "/images/meze.jpeg"
        },
        {
          id: 29,
          name: "PATATES",
          nameEn: "POTATOES, КАРТОФЕЛЬ",
          price: "TEK 270 TL",
          image: "/images/patates .png"
        }
      ]
    }
  };

  return (
    <div className="coffee_section">
      {Object.entries(menuData).map(([categoryKey, categoryData]) => (
        <MenuCategory
          key={categoryKey}
          title={categoryData.title}
          items={categoryData.items}
        />
      ))}
    </div>
  );
};

export default Menu;
